// extracted by mini-css-extract-plugin
module.exports = {"editor":"editorViewer_editor__TTNLz","placeholder":"editorViewer_placeholder__jQ6V5","t1":"editorViewer_t1__TmpW9","t2":"editorViewer_t2__wWv3j","t3":"editorViewer_t3__0p8H1"};